module.exports = __webpack_public_path__ + "img/6.834b58d9.jpg";